<div>
  <div [hidden]="!loading" class="spinner">
    <div class="sk-spinner sk-spinner-pulse"></div>
  </div>
  <div>
    <ag-grid-angular
      style="width: 100%; height: 100%"
      class="ag-theme-alpine"
      rowSelection="multiple"
      rowHeight="48"
      rowMultiSelectWithClick="false"
      suppressRowClickSelection="true"
      suppressDragLeaveHidesColumns="true"
      suppressMenuHide="true"
      enableCellTextSelection="true"
      [icons]="customIcons"
      [columnDefs]="columnDefs"
      [tooltipShowDelay]="500"
      [defaultColDef]="defaultColDef"
      [paginationPageSize]="paginationPageSize"
      [pagination]="true"
      [suppressPaginationPanel]="true"
      [suppressCellSelection]="true"
      [suppressScrollOnNewData]="true"
      [rowData]="rowData"
      [domLayout]="domLayout"
      [getContextMenuItems]="getContextMenuItems"
      (columnMoved)="onColumnMoved($event)"
      (rowSelected)="onRowSelected()"
      (columnResized)="onColumnResized($event)"
      (columnVisible)="onColumnVisible($event)"
      (sortChanged)="onSortChange()"
      (gridReady)="onGridReady($event)"></ag-grid-angular>
  </div>

  <div class="d-flex justify-content-between align-items-center my-15 has-pagination">
    <div class="pagination-left">
      <app-pagination
        *ngIf="totalRowsCount > paginationPageSize"
        [totalItems]="totalRowsCount"
        [(currentPage)]="currentPageNumber"
        (change)="onPageChange($event)"
        [pageSize]="paginationPageSize"></app-pagination>
    </div>

    <div class="d-flex align-items-center justify-content-end pagination-right">
      <span class="pagination-count"
        >Showing {{ totalRowsCount > paginationPageSize ? paginationPageSize : totalRowsCount }} of {{ totalRowsCount }} results</span
      >
      <ul *ngIf="sizes.length" class="pagination">
        <li *ngFor="let size of sizes" [ngClass]="{ active: size === paginationPageSize }">
          <a tabindex="0" (keyup.enter)="changeSize($event, size)" (click)="changeSize($event, size)">{{ size }}</a>
        </li>
      </ul>
    </div>
  </div>
</div>

<ng-template #infoModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">{{ numberDetailsPhone }} details</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body modal-body-details">
    <div [hidden]="numberDetails && userModel" class="spinner">
      <div class="sk-spinner sk-spinner-pulse"></div>
    </div>
    <div class="d-flex modal-tabs-vertical">
      <ul class="nav flex-column">
        <div tabindex="0" (keyup.enter)="scrollTo('appscripts-numbers-details-main')" (click)="scrollTo('appscripts-numbers-details-main')">
          <a class="nav-link cp" [ngClass]="{ active: currentSection === 'appscripts-numbers-details-main' }">
            <span class="nav-text"> Main</span>
          </a>
        </div>
        <div tabindex="0" (keyup.enter)="scrollTo('appscripts-numbers-details-status')" (click)="scrollTo('appscripts-numbers-details-status')">
          <a class="nav-link cp" [ngClass]="{ active: currentSection === 'appscripts-numbers-details-status' }">
            <span class="nav-text"> Status</span>
          </a>
        </div>
        <div tabindex="0" (keyup.enter)="scrollTo('appscripts-numbers-details-mo')" (click)="scrollTo('appscripts-numbers-details-mo')">
          <a class="nav-link cp" [ngClass]="{ active: currentSection === 'appscripts-numbers-details-mo' }">
            <span class="nav-text"> MO</span>
          </a>
        </div>
        <div tabindex="0" (keyup.enter)="scrollTo('appscripts-numbers-details-device')" (click)="scrollTo('appscripts-numbers-details-device')">
          <a class="nav-link cp" [ngClass]="{ active: currentSection === 'appscripts-numbers-details-device' }">
            <span class="nav-text"> Device</span>
          </a>
        </div>
        <div (keyup.enter)="scrollTo('appscripts-numbers-details-other')" tabindex="0" (click)="scrollTo('appscripts-numbers-details-other')">
          <a class="nav-link cp" [ngClass]="{ active: currentSection === 'appscripts-numbers-details-other' }">
            <span class="nav-text"> Other</span>
          </a>
        </div>
      </ul>
      <div class="tab-content section-parent">
        <div id="appscripts-numbers-details-main" class="section-child">
          <h4>Main</h4>
          <form (ngSubmit)="onSubmitNumber()" [formGroup]="numberForm" class="pos-relative form">
            <div>
              <div class="form-group my-15 row">
                <div class="col-md-6">
                  <label class="form-label required">Phone</label>
                  <input formControlName="phoneNumber" type="text" class="form-control" />
                  <input-errors [control]="numberForm.controls.phoneNumber" [service]="validationService"></input-errors>
                </div>
                <div class="col-md-3">
                  <div>
                    <label class="form-label" (keyup.enter)="blocked.click()" tabindex="0" (click)="blocked.click()">Blocked</label>
                    <div class="form-switch">
                      <input #blocked type="checkbox" class="form-check-input medium" formControlName="blocked" />
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div>
                    <label class="form-label" (keyup.enter)="updateHlr.click()" tabindex="0" (click)="updateHlr.click()">Autoupdate HLR</label>
                    <div class="form-switch">
                      <input #updateHlr type="checkbox" class="form-check-input medium" formControlName="updateHlr" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group my-15 row">
                <div class="col-md-6 relative">
                  <label class="form-label">Country </label>
                  <input formControlName="country" type="text" class="form-control form-control-with-spinner" />
                  <span class="input-spinner" [hidden]="!networkInfoLoading">
                    <i class="fa fa-spinner fa-spin"></i>
                  </span>
                  <input-errors [control]="numberForm.controls.country" [service]="validationService"></input-errors>
                </div>
                <div class="col-md-6">
                  <label class="form-label required">MCC</label>
                  <input formControlName="mcc" type="text" class="form-control" />
                  <input-errors [control]="numberForm.controls.mcc" [service]="validationService"></input-errors>
                </div>
              </div>
              <div class="form-group my-15 row">
                <div class="col-md-6 relative">
                  <label class="form-label">Network </label>
                  <input formControlName="provider" type="text" class="form-control form-control-with-spinner" />
                  <span class="input-spinner" [hidden]="!networkInfoLoading">
                    <i class="fa fa-spinner fa-spin"></i>
                  </span>
                  <input-errors [control]="numberForm.controls.provider" [service]="validationService"></input-errors>
                </div>
                <div class="col-md-6">
                  <label class="form-label required">MNC</label>
                  <input formControlName="mnc" type="text" class="form-control" />
                  <input-errors [control]="numberForm.controls.mnc" [service]="validationService"></input-errors>
                </div>
              </div>
              <div class="form-group my-15 row">
                <div class="col-md-6 relative">
                  <label class="form-label">Original network </label>
                  <input formControlName="originalProvider" type="text" class="form-control form-control-with-spinner" />
                  <span class="input-spinner" [hidden]="!networkInfoLoading">
                    <i class="fa fa-spinner fa-spin"></i>
                  </span>
                  <input-errors [control]="numberForm.controls.originalProvider" [service]="validationService"></input-errors>
                </div>
                <div class="col-md-6">
                  <label class="form-label">Original MNC</label>
                  <input formControlName="originalMnc" type="text" class="form-control" />
                  <input-errors [control]="numberForm.controls.originalMnc" [service]="validationService"></input-errors>
                </div>
              </div>
              <div class="hr-line-dashed"></div>
              <div class="text-right buttons">
                <button id="btn-appscripts-number" type="submit" [disabled]="!numberForm.valid" class="btn btn-primary m-b m-r">Apply</button>
              </div>
            </div>
          </form>
          <hr />
          <form (ngSubmit)="onSubmitUser()" [formGroup]="userForm" class="pos-relative form">
            <div *ngIf="userModel">
              <div class="form-group my-15 row">
                <div class="col-md-12">
                  <label class="form-label required">Email</label>
                  <input [(ngModel)]="userModel.email" formControlName="email" type="text" class="form-control" />
                  <input-errors [control]="userForm.controls.email" [service]="validationService"></input-errors>
                </div>
              </div>
              <div class="form-group my-15 row">
                <div class="col-md-12">
                  <label class="form-label" for="appscripts-full-name">Full legal name</label>
                  <input id="appscripts-full-name" [value]="userData.fullName || ''" type="text" class="form-control" readonly />
                </div>
              </div>
              <div class="form-group my-15 row">
                <div class="col-md-6">
                  <label class="form-label">Payment method</label>
                  <input [(ngModel)]="userModel.paymentMethodName" formControlName="paymentMethodName" type="text" class="form-control" />
                  <input-errors [control]="userForm.controls.paymentMethodName" [service]="validationService"></input-errors>
                </div>
                <div class="col-md-6">
                  <label class="form-label">Payment address</label>
                  <input [(ngModel)]="userModel.paymentAddress" formControlName="paymentAddress" type="text" class="form-control" />
                  <input-errors [control]="userForm.controls.paymentAddress" [service]="validationService"></input-errors>
                </div>
              </div>
              <div class="form-group my-15 row">
                <div class="col-md-6">
                  <label class="form-label" tooltip="The (referral) code of another user that was entered at the registration">Referrer</label>
                  <input [(ngModel)]="userModel.referrerCode" formControlName="referrerCode" type="text" class="form-control" />
                  <input-errors [control]="userForm.controls.referrerCode" [service]="validationService"></input-errors>
                </div>
                <div class="col-md-6">
                  <label class="form-label" tooltip="The unique code assigned to this user that can be shared with others">Referral code</label>
                  <input [(ngModel)]="userModel.referralCode" formControlName="referralCode" type="text" class="form-control" />
                  <input-errors [control]="userForm.controls.referralCode" [service]="validationService"></input-errors>
                </div>
              </div>
              <div class="text-right buttons my-15">
                <button id="btn-appscripts-user" type="submit" [disabled]="!userForm.valid" class="btn btn-primary m-b m-r">Apply</button>
              </div>
            </div>
          </form>
          <hr />
        </div>
        <div id="appscripts-numbers-details-status" class="section-child">
          <h4>Status</h4>
          <dl *ngIf="numberDetails" class="description-list">
            <dt class="text-muted" tooltip="Current balance of the user" tooltipPlacement="top">Balance</dt>
            <dd>{{ userData.balance / 100 | currency: 'EUR' : 'symbol' }}</dd>
            <dt class="text-muted" tooltip="SMS count / Rate" tooltipPlacement="top">MT billing</dt>
            <dd>
              {{ numberDetails.mtSmsCount }} /
              <ng-container *ngIf="numberDetails.mtSmsRate">{{ numberDetails.mtSmsRate / 100 | currency: 'EUR' : 'symbol' }}</ng-container>
            </dd>
            <dt class="text-muted">Registration date</dt>
            <dd>{{ formatDate(userData.registeredAt) }}</dd>
            <dt class="text-muted">Email verified</dt>
            <dd [ngClass]="{ 'text-danger': !numberDetails.verificationInfo.is_verify_email }">
              {{ numberDetails.verificationInfo.is_verify_email ? 'yes' : 'no' }}
            </dd>
            <dt class="text-muted">Phone verified</dt>
            <dd [ngClass]="{ 'text-danger': !numberDetails.verificationInfo.is_verify }">
              {{ numberDetails.verificationInfo.is_verify ? 'yes' : 'no' }}
            </dd>
            <dt class="text-muted">SIM_ID verified</dt>
            <dd [ngClass]="{ 'text-danger': numberDetails.waitingSimIdCheck }">{{ numberDetails.waitingSimIdCheck ? 'no' : 'yes' }}</dd>
            <dt class="text-muted" tooltip="Timestamp of the last ping received from this number" tooltipPlacement="top">Last active</dt>
            <dd>{{ formatDate(userData.lastActive) }}</dd>
            <dt class="text-muted" tooltip="Timestamp of the last received SMS by this user" tooltipPlacement="top">Last MT SMS</dt>
            <dd>{{ formatDate(numberDetails.lastMtSmsReceivedAt) }}</dd>
            <dt class="text-muted" tooltip="Timestamp of the last sent SMS from this user" tooltipPlacement="top">Last MO SMS</dt>
            <dd>{{ formatDate(numberDetails.lastMoSmsReceivedAt) }}</dd>
            <dt
              class="text-muted"
              tooltip="A value between 0 and 180 indicating availability of this user within the last 24h, 0 - not available at all, 180 - available the whole time"
              tooltipPlacement="top">
              Available index
            </dt>
            <dd>{{ numberDetails.availableIndexHistory.length ? numberDetails.availableIndexHistory[0].value : '-' }}</dd>
            <dt
              class="text-muted"
              tooltip="A value indicating how likely it is that this number has been whitelisted - the higher the more likely. 1 for each received SMS, 200 for each customer report (issue reports)"
              tooltipPlacement="top">
              Whitelisting index
            </dt>
            <dd>{{ numberDetails.whiteIndexHistory.length ? numberDetails.whiteIndexHistory[0].value : '-' }}</dd>
            <dt class="text-muted" tooltip="Status of the last payment request" tooltipPlacement="top">Last payment request</dt>
            <dd>
              <ng-container *ngIf="numberDetails.lastPaymentRequest">
                {{ formatDate(numberDetails.lastPaymentRequest.createdAt) }}
                &nbsp;
                <ng-container *ngIf="numberDetails.lastPaymentRequest.status === 'PAID'">
                  <span class="text-success">{{ numberDetails.lastPaymentRequest.status }}</span>
                </ng-container>
                <ng-container *ngIf="numberDetails.lastPaymentRequest.status === 'FAILED'">
                  <span class="text-danger">{{ numberDetails.lastPaymentRequest.status }}</span>
                </ng-container>
                <ng-container *ngIf="numberDetails.lastPaymentRequest.status !== 'PAID' && numberDetails.lastPaymentRequest.status !== 'FAILED'">
                  <span class="text-muted">{{ numberDetails.lastPaymentRequest.status }}</span>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="!numberDetails.lastPaymentRequest">-</ng-container>
            </dd>
          </dl>
          <hr />
        </div>
        <div id="appscripts-numbers-details-mo" class="section-child">
          <h4>MO</h4>
          <dl *ngIf="numberVerificationInfo" class="description-list long-text">
            <dt class="text-muted">Total verif. attempts</dt>
            <dd>{{ numberVerificationInfo.totalVerificationAttempts }}</dd>

            <dt class="text-muted">Since last reset</dt>
            <dd>
              {{ numberVerificationInfo.verificationAttemptSinceReset === null ? '-' : numberVerificationInfo.verificationAttemptSinceReset }}
              &nbsp;&nbsp;&nbsp;&nbsp;
              <button
                *ngIf="showNumberVerificationResetButton && numberVerificationInfo.verificationAttemptSinceReset !== 0"
                type="button"
                class="btn btn-sm btn-primary reset-button"
                (click)="onClickReset()">
                Reset
              </button>
              <i
                *ngIf="!showNumberVerificationResetButton && numberVerificationInfo.verificationAttemptSinceReset !== 0"
                class="fa fa-spinner fa-spin"></i>
            </dd>

            <dt class="text-muted">Successful</dt>
            <dd>{{ numberVerificationInfo.verificationSucceededAttempt === null ? '-' : numberVerificationInfo.verificationSucceededAttempt }}</dd>
            <dt class="text-muted" tooltip="The user has enabled Sending SMS in the app" tooltipPlacement="top">SMS sending allowed</dt>
            <dd [ngClass]="{ 'text-danger': !numberDetails?.smsSendingAllowed }">{{ numberDetails?.smsSendingAllowed ? 'yes' : 'no' }}</dd>
          </dl>
          <hr />
        </div>
        <div id="appscripts-numbers-details-device" class="section-child">
          <h4>Device</h4>
          <dl *ngIf="numberDetails" class="description-list">
            <dt class="text-muted">Android</dt>
            <dd>{{ numberDetails.androidVersion }}</dd>
            <dt class="text-muted">Application</dt>
            <dd>{{ numberDetails.appVersion }}</dd>
            <dt class="text-muted">Device model</dt>
            <dd>{{ numberDetails.deviceModel }}</dd>
            <dt class="text-muted">Sim state</dt>
            <dd>
              {{ numberDetails.simState }} <span class="badge bg-primary">{{ formatDate(numberDetails.simStateUpdatedAt) }}</span>
            </dd>
            <dt class="text-muted">Service state</dt>
            <dd>
              {{ numberDetails.serviceState }} <span class="badge bg-primary">{{ formatDate(numberDetails.serviceStateUpdatedAt) }}</span>
            </dd>
            <dt class="text-muted" tooltip="Yes - the user is currently roaming, No - the user is in their home country" tooltipPlacement="top">
              Roaming
            </dt>
            <dd>{{ numberDetails.roaming ? 'Yes' : 'No' }}</dd>
            <dt
              class="text-muted"
              tooltip="We have sim_id of this user - we need sim_id to be able to send SMS from this user"
              tooltipPlacement="top">
              Sim info
            </dt>
            <dd [ngClass]="{ 'text-danger': !numberDetails.hasSimInfo }">{{ numberDetails.hasSimInfo ? 'yes' : 'no' }}</dd>
            <dt
              class="text-muted"
              tooltip="We have device_token of this user - this token is required to send push notifications to the device"
              tooltipPlacement="top">
              FCM token
            </dt>
            <dd [ngClass]="{ 'text-danger': !numberDetails.hasFcmToken }">{{ numberDetails.hasFcmToken ? 'yes' : 'no' }}</dd>
          </dl>
          <hr />
        </div>
        <div id="appscripts-numbers-details-other" class="section-child">
          <h4>Other</h4>

          @if (showPingsWarnBanner) {
            <div class="logs-warn-wrapper">
              <span class="icon-help-1 text-primary-p8 mx-0_5 mt-0_2"></span>

              <div>
                <p class="mb-0_5">
                  Please note that the <strong>pings</strong>, <strong>AI</strong> and <strong>WI</strong> are calculated based on both:
                </p>
                <ul class="logs-warn-list mb-0_5">
                  <li><strong>PROD pings</strong> - which are being duplicated for DEV</li>
                  <li><strong>DEV pings</strong> (if present) - coming from DEV version of our APK (internal testing only)</li>
                </ul>

                <p class="mb-0">
                  In case the number was online with both <strong>PROD</strong> and <strong>DEV</strong> version of the APK within the relevant
                  period, those pings are merged and both considered in the AI and WI calculations.
                </p>
              </div>
            </div>
          }

          <div *ngIf="numberDetails" class="row">
            <div class="col-md-4">
              <div class="card panel-fixed-height">
                <div class="card-header">Ping history</div>
                <div class="card-body">
                  <div *ngIf="!numberDetails.pingHistory.length" class="text-center text-muted">Empty</div>
                  <ul class="list-group">
                    <li *ngFor="let ping of numberDetails.pingHistory" class="list-group-item">
                      {{ formatDate(ping.timestamp) }} <span class="text-info">{{ ping.pingWeight }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card panel-fixed-height">
                <div class="card-header">AI history</div>
                <div class="card-body">
                  <div *ngIf="!numberDetails.availableIndexHistory.length" class="text-center text-muted">Empty</div>
                  <ul class="list-group">
                    <li *ngFor="let ai of numberDetails.availableIndexHistory" class="list-group-item">
                      {{ formatDate(ai.created_at) }} <span class="text-info">{{ ai.value }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card panel-fixed-height">
                <div class="card-header">WI history</div>
                <div class="card-body">
                  <div *ngIf="!numberDetails.whiteIndexHistory.length" class="text-center text-muted">Empty</div>
                  <ul class="list-group">
                    <li *ngFor="let wi of numberDetails.whiteIndexHistory" class="list-group-item">
                      {{ formatDate(wi.created_at) }} <span class="text-info">{{ wi.value }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="section-empty-child"></div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #balanceModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Balance</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <app-appscripts-balance-form [userId]="balanceUserId" (onAfterSave)="onAfterSaveBalance()"></app-appscripts-balance-form>
  </div>
</ng-template>

<ng-template #deleteModalTpl let-dialogRef="dialogRef">
  <deletemodal [dialogRef]="dialogRef" [message]="'Delete the user and all related numbers?'"></deletemodal>
</ng-template>

<ng-template #commentModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Phone number comment</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>

  <div class="modal-body">
    <form (ngSubmit)="onCommentSave()" [formGroup]="phoneNumberCommentForm" class="mb-20">
      <div class="form-group mb-20">
        <span class="radio-title">Issue</span>
        <div class="form-check mb-15" *ngFor="let item of phoneNumberCommentIssues">
          <input [id]="item.id" class="form-check-input cp" type="radio" [value]="item.id" formControlName="commentIssue" />
          <label [for]="item.id" class="form-check-label cp" tabindex="0">
            {{ item.label }}
          </label>
        </div>
      </div>

      <div class="form-group">
        <label for="number" class="form-label">Description</label>
        <textarea formControlName="comment" class="form-control" placeholder="Type comment" rows="3"></textarea>
      </div>
    </form>
  </div>
  <div class="modal-footer pt-15">
    <div class="button-holder d-flex justify-content-between align-items-center">
      <button class="btn btn-outline-dark px-20" (click)="dialogRef.close(false)">Cancel</button>
      <button class="btn btn-primary px-20" (click)="onCommentSave()" [disabled]="loading || phoneNumberCommentForm.invalid">Save</button>
    </div>
  </div>
</ng-template>
